import { Card } from '@buyerflo/ui/components/Card'
import Button from 'components/button'
import { SizableText, YStack } from 'tamagui'
import { useUserData } from 'auth'
import { CheckItem } from '../CheckItem'
import { useOnboarding } from '../OnboardingContext'

export default function LogoGuide() {
    const { setCurrentStep, startStepTour } = useOnboarding()
    const { user } = useUserData()

    const hasLogo = !!user.orgLogo

    return (
        <YStack gap="$4">
            <SizableText size="$6" fontWeight="700">
                Upload Your Logo
            </SizableText>
            <SizableText size="$3" color="$colorSoft">
                Add your company logo so it appears on forms, invoices, and your public wishlist page.
            </SizableText>

            <Card padding="$3" gap="$2">
                <CheckItem checked={hasLogo} label="Upload company logo" />
            </Card>

            {!hasLogo && (
                <Button
                    size="$4"
                    theme="primary"
                    onPress={() => startStepTour('logo')}
                >
                    Show me
                </Button>
            )}

            {hasLogo && (
                <Button
                    size="$3"
                    variant="outlined"
                    onPress={() => setCurrentStep(1)}
                >
                    Next step
                </Button>
            )}
        </YStack>
    )
}
